import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=52e4f431&scoped=true&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./base.css?vue&type=style&index=1&lang=css&"
import style2 from "./Item.vue?vue&type=style&index=2&id=52e4f431&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e4f431",
  null
  
)

export default component.exports